import React, { useState, useEffect } from 'react'
import { IClinic, IEditStaffMember, ITextInput } from '../../helpers/Interfaces';
import ApiService from '../../services/ApiService';
import DocumentButton from '../DocumentButton/DocumentButton';
import Input from '../Input/Input';
import InputDropDown from '../InputDropDown/InputDropDown';
import Modal from '../Modal/Modal';

import "../AddUserModal/AddUserModal.scss"

function EditUserModal(props: { open: boolean; close: CallableFunction; selectedUserId: string; }) {

    const apiService = new ApiService();

    const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "", phoneNumber: "", clinicId: "" });
    const [formDataErrors, setFormDataErrors] = useState({
        firstNameError: { showError: false, message: "" }, lastNameError: { showError: false, message: "" },
        emailError: { showError: false, message: "" }, clinicIdError: { showError: false, message: "" }
    });
    const [showAlert, setShowAlert] = useState({ isError: false, message: "", open: false });
    const [loading, setLoading] = useState(false);
    const [clinics, setClinics] = useState([] as ITextInput[]);

    useEffect(() => {
        getClinics();
    }, [])

    useEffect(() => {
        if (props.selectedUserId) {
            getStaffMemberById();
        }
    }, [props.selectedUserId])

    function getStaffMemberById() {

        setLoading(true);

        let data = {
            staffMemberId: props.selectedUserId
        }

        apiService.getStaffMemberById(data).then((result) => {

            let data = result.data;

            if (!data?.isSuccessful) {
                let newShowAlert = showAlert;
                newShowAlert.isError = true;
                newShowAlert.message = data?.errorMessage;
                newShowAlert.open = true;
                setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
                return;
            }

            loadData(data?.staffMember);
        }).catch(() => {
            let newShowAlert = showAlert;
            newShowAlert.isError = true;
            newShowAlert.message = "Unexpected Error";
            newShowAlert.open = true;
            setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
        }).finally(() => {
            setLoading(false);
        });
    }

    function getClinics() {

        setLoading(true);

        let data = {
            doctorId: null
        }

        apiService.getClinicsByDoctorId(data).then((result) => {

            let data = result.data;

            if (!data?.isSuccessful) {
                let newShowAlert = showAlert;
                newShowAlert.isError = true;
                newShowAlert.message = data?.errorMessage;
                newShowAlert.open = true;
                setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
                return;
            }

            getClinicTextInput(data?.clinics);
        }).catch(() => {
            let newShowAlert = showAlert;
            newShowAlert.isError = true;
            newShowAlert.message = "Unexpected Error";
            newShowAlert.open = true;
            setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
        }).finally(() => {
            setLoading(false);
        });
    }

    function loadData(selectedStaffMember: IEditStaffMember) {
        let newFormData = formData;
        newFormData.firstName = selectedStaffMember.firstName;
        newFormData.lastName = selectedStaffMember.lastName;
        newFormData.email = selectedStaffMember.email;
        newFormData.phoneNumber = selectedStaffMember.phoneNumber;
        newFormData.clinicId = selectedStaffMember.clinicId;
        setFormData((prevDetails: any) => ({ ...prevDetails, ...newFormData, }));
    }

    function getClinicTextInput(clinics: IClinic[]) {

        setLoading(true);

        let clinicsArr = [] as ITextInput[];

        clinics.forEach(clinic => {
            let data = {
                label: clinic.clinicName,
                value: clinic.id
            }

            clinicsArr.push(data);
        });

        setClinics(clinicsArr);

        setLoading(false);
    }

    const handleClose = (shouldUpdate: boolean) => {
        clearData();
        props.close("edit", shouldUpdate);
    }

    const closeAlert = () => {
        let newShowAlert = showAlert;
        newShowAlert.open = false;
        setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
    }

    function clearData() {
        let newFormData = formData;
        newFormData.firstName = "";
        newFormData.lastName = "";
        newFormData.email = "";
        newFormData.phoneNumber = "";
        newFormData.clinicId = "";
        setFormData((prevDetails: any) => ({ ...prevDetails, ...newFormData, }));

        let newFormDataErrors = formDataErrors;
        newFormDataErrors.firstNameError.showError = false;
        newFormDataErrors.lastNameError.showError = false;
        newFormDataErrors.emailError.showError = false;
        newFormDataErrors.clinicIdError.showError = false;
        setFormDataErrors((prevDetails) => ({ ...prevDetails, ...newFormDataErrors }));

        let newShowAlert = showAlert;
        newShowAlert.open = false;
        setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));

        setLoading(false);
    }

    function update() {

        setLoading(true);

        if (formData.firstName?.trim() === "") {
            let newFormDataErrors = formDataErrors;
            newFormDataErrors.firstNameError.showError = true;
            newFormDataErrors.firstNameError.message = "REQUIRED";
            setFormDataErrors((prevDetails) => ({ ...prevDetails, ...newFormDataErrors }));
            setLoading(false);
            return;
        } else {
            let newFormDataErrors = formDataErrors;
            newFormDataErrors.firstNameError.showError = false;
            setFormDataErrors((prevDetails) => ({ ...prevDetails, ...newFormDataErrors }));
        }

        if (formData.lastName?.trim() === "") {
            let newFormDataErrors = formDataErrors;
            newFormDataErrors.lastNameError.showError = true;
            newFormDataErrors.lastNameError.message = "REQUIRED";
            setFormDataErrors((prevDetails) => ({ ...prevDetails, ...newFormDataErrors }));
            setLoading(false);
            return;
        } else {
            let newFormDataErrors = formDataErrors;
            newFormDataErrors.lastNameError.showError = false;
            setFormDataErrors((prevDetails) => ({ ...prevDetails, ...newFormDataErrors }));
        }

        if (formData.email?.trim() === "") {
            let newFormDataErrors = formDataErrors;
            newFormDataErrors.emailError.showError = true;
            newFormDataErrors.emailError.message = "REQUIRED";
            setFormDataErrors((prevDetails) => ({ ...prevDetails, ...newFormDataErrors }));
            setLoading(false);
            return;
        } else {
            let newFormDataErrors = formDataErrors;
            newFormDataErrors.emailError.showError = false;
            setFormDataErrors((prevDetails) => ({ ...prevDetails, ...newFormDataErrors }));
        }

        if (formData.clinicId?.trim() === "") {
            let newFormDataErrors = formDataErrors;
            newFormDataErrors.clinicIdError.showError = true;
            newFormDataErrors.clinicIdError.message = "REQUIRED";
            setFormDataErrors((prevDetails) => ({ ...prevDetails, ...newFormDataErrors }));
            setLoading(false);
            return;
        } else {
            let newFormDataErrors = formDataErrors;
            newFormDataErrors.clinicIdError.showError = false;
            setFormDataErrors((prevDetails) => ({ ...prevDetails, ...newFormDataErrors }));
        }

        let data = Object.assign(formData, { id: props.selectedUserId });

        apiService.updateSupportStaff(data).then((result) => {

            let data = result.data;

            if (!data?.isSuccessful) {
                let newShowAlert = showAlert;
                newShowAlert.isError = true;
                newShowAlert.message = data?.errorMessage;
                newShowAlert.open = true;
                setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
                return;
            }

            let newShowAlert = showAlert;
            newShowAlert.isError = false;
            newShowAlert.message = formData.firstName + " " + formData.lastName + " Updated";
            newShowAlert.open = true;
            setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));

            handleClose(true);
        }).catch(() => {
            let newShowAlert = showAlert;
            newShowAlert.isError = true;
            newShowAlert.message = "Unexpected Error";
            newShowAlert.open = true;
            setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <Modal showAlert={showAlert} closeAlert={closeAlert} editable={false} open={props.open} close={handleClose}
            style={"add-user-card"} >
            <div className="add-staff-mem-container">
                <div className='title'>Edit Staff Member</div>
                <div className="row">
                    <div className="input-field">
                        <Input label='FIRST NAME*' value={formData.firstName} type='text' showError={formDataErrors.firstNameError.showError}
                            onChange={(value: any) => {
                                let newFormData = formData;
                                newFormData.firstName = value;
                                setFormData((prevDetails: any) => ({ ...prevDetails, ...newFormData }));
                            }} />
                    </div>
                    <div className="input-field">
                        <Input label='LAST NAME*' value={formData.lastName} type='text' showError={formDataErrors.lastNameError.showError}
                            onChange={(value: any) => {
                                var newFormData = formData;
                                newFormData.lastName = value;
                                setFormData((prevDetails: any) => ({ ...prevDetails, ...newFormData }));
                            }} />
                    </div>
                    <div className="input-field">
                        <Input label='EMAIL ADDRESS*' value={formData.email} type='text' showError={formDataErrors.emailError.showError}
                            onChange={(value: any) => {
                                let newFormData = formData;
                                newFormData.email = value;
                                setFormData((prevDetails: any) => ({ ...prevDetails, ...newFormData }));
                            }} />
                    </div>
                    <div className="input-field">
                        <Input label='TELEPHONE NUMBER' value={formData.phoneNumber} type='text'
                            onChange={(value: any) => {
                                let newFormData = formData;
                                newFormData.phoneNumber = value;
                                setFormData((prevDetails: any) => ({ ...prevDetails, ...newFormData }));
                            }} />
                    </div>
                    <div className="input-field">
                        <div className="input-drd">
                            <InputDropDown title='ASSIGN CLINIC*' values={clinics} type='search'
                                showError={formDataErrors.clinicIdError.showError}
                                defaultValue={formData.clinicId}
                                onSelect={(value: any) => {
                                    if (value) {
                                        let newFormData = formData;
                                        newFormData.clinicId = value[0].value;
                                        setFormData((prevDetails: any) => ({ ...prevDetails, ...newFormData }))
                                    }
                                }} />
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <span onClick={() => { handleClose(false) }} className="cancel-btn">Cancel</span>
                    <div className="button">
                        <DocumentButton loading={loading} onClick={() => { update(); }} text={"Update"} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default EditUserModal